import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button, TextField, SkeletonDisplayText, SkeletonBodyText, TextContainer, Banner } from '@shopify/polaris'

import logoDescImg from 'assets/intro_illustration.png'
import Text from 'components/common/Text'
import { SHOPIFY_TEXT, SHOPIFY_TEXT_HEADER, SHOPIFY_GRAY, SHOPIFY_BLUE } from 'components/styles'
import { sendPreviewSms } from 'controllers/shopifyApp'

const Wrapper = styled.div`
  height: 40em;
  display: flex;
  align-items: center;
`
const Container = styled.div`
  width: 40em;
  display: flex;
  flex-direction: column;
`
const DescContainer = styled.div`
  margin-top: 2em;
  width: 21em;
`
const Image = styled.div`
  background-image: url('${logoDescImg}');
  background-repeat: no-repeat;
  background-size: contain;
  width: 13em;
  margin-top: 5em;
  margin-left: 2em;
`
const ImagePreview = styled.div`
  background-color: ${SHOPIFY_GRAY};
  background-size: contain;
  width: 13em;
  margin-top: 5em;
  margin-left: 2em;
`
const ButtonsContainer = styled.div`
  margin-top: 3em;
  width: 40em;
  display: flex;
  justify-content: flex-start;
  font-size: 0.8em;
`
const InputContainer = styled.div`
  display:flex;
  flex-direction: row;
  margin-left: 2em;
  align-items: center;

  .Polaris-TextField {
    width: 15em;
    height: 3em;
  }
`
const MiddleContainer = styled.div`
  display: flex;
`
const BannerContainer = styled.div`
  position: absolute;
  top: 3em;
  font-size: 0.8em;
`

const DESC_MODE = 'DESC_MODE'
const INPUT_MODE = 'INPUT_MODE'
const SENT_MODE = 'SENT_MODE'

class IntroIllustrationDesc extends Component {

  constructor (props) {
    super(props)
    this.state = {
      inputMode: DESC_MODE,
      phone: '',
      sending: false,
      showWarning: false
    }
  }

  onSendToDeviceClick = () => this.setState({inputMode: INPUT_MODE})
  onPhoneEnter = (v) => {
    const pattern = /^\+?\d+(-\d+)*$/
    if (pattern.test(v) || v === '' || v === '+') this.setState({phone: v})
  }

  componentWillUnmount () {
    this.smsSentCallback = () => null
    this.hideWarning = () => null
    clearTimeout(this.timer)
  }

  hideWarning = () => {
    this.setState({
      showWarning: false
    })
  }

  smsSentCallback = (success) => {
    if (success) {
      this.setState({
        inputMode: SENT_MODE,
        sending: false
      })
    } else {
      this.setState({
        inputMode: INPUT_MODE,
        sending: false,
        showWarning: true
      })
      this.timer = setTimeout(this.hideWarning, 3000)
    }
  }

  send = () => {
    const { dispatch } = this.props
    const { phone } = this.state
    if (phone !== '' && phone.length >= 9) {
      this.setState({sending: true}, () => dispatch(sendPreviewSms(phone, this.smsSentCallback)))
    }
  }

  renderSendToDevice = () => {
    const { inputMode, phone, sending } = this.state
    if (inputMode === INPUT_MODE) {
      return (
        <InputContainer>
          <TextField
            placeholder='Enter your mobile number'
            value={phone}
            onChange={this.onPhoneEnter}
            readOnly={sending}
            type='tel'
            autoComplete
          />
          <Button
            size='slim'
            onClick={this.send}
            disabled={sending}
            loading={sending}
          >
            Send
          </Button>
        </InputContainer>
      )
    } else if (inputMode === DESC_MODE) {
      return (
        <InputContainer>
          <Button plain onClick={this.onSendToDeviceClick} size='slim'>Preview on a mobile device</Button>
        </InputContainer>
      )
    } else {
      return (
        <InputContainer>
          <Text styleRaw={'width: 13em'}>
            {`Preview sent to`}
          </Text>
          <Text color={SHOPIFY_BLUE} styleRaw={'font-size: 1.1em; font-weight: 600;'}>
            {phone}
          </Text>
        </InputContainer>
      )
    }
  }

  renderWarningBanner () {
    const { phone, showWarning } = this.state
    if (showWarning) {
      return (
        <BannerContainer>
          <Banner
            title={`Sms was not sent to the specified number ${phone}`}
            status='warning'
          >
            <Text>You probably need to use internationally-standardized format for number</Text>
          </Banner>
        </BannerContainer>
      )
    }
  }

  render () {
    const { goNext, isLoading } = this.props
    if (isLoading) {
      return (
        <Wrapper>
          <Container>
            <MiddleContainer>
              <DescContainer>
                <TextContainer>
                  <SkeletonDisplayText />
                  <SkeletonBodyText lines={5} />
                  <TextContainer>
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </TextContainer>
              </DescContainer>
              <ImagePreview />
            </MiddleContainer>
          </Container>
        </Wrapper>
      )
    } else {
      return (
        <Wrapper>
          {this.renderWarningBanner()}
          <Container>
            <Text size='large' color={SHOPIFY_TEXT_HEADER}>Here's a taste of your Whimm</Text>
            <MiddleContainer>
              <DescContainer>
                <Text containerStyle={`line-height: 1.4em;`} color={SHOPIFY_TEXT}>
                  Click on the Preview button for a short Whimm that we created just for you! This fully interactive app-like shop entrance shows how Whimm will convert visitors into shoppers as they enter your Shopify store.
                </Text>
                <Text containerStyle={`line-height: 1.4em; margin-top: 1em;`} color={SHOPIFY_TEXT}>
                  Next, let's take the first step towards selling more beautifully!
                </Text>
              </DescContainer>
              <Image />
            </MiddleContainer>
            <ButtonsContainer>
              <Button primary onClick={goNext} size='slim'>Start Customizing</Button>
              {this.renderSendToDevice()}
            </ButtonsContainer>
          </Container>
        </Wrapper>
      )
    }
  }
}


IntroIllustrationDesc.propTypes = {
  goNext: PropTypes.func, //.isRequired
  isLoading: PropTypes.bool
}

export default connect()(IntroIllustrationDesc)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/IntroIllustrationDesc.js